module.exports = __webpack_public_path__ + "static/media/paperclip-vector-6.d465b791.png";